import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ExternalLinksService, LocalStorageService } from '@app/core/services';

@Component({
  selector: 'ingo-mobile-app-modal-container',
  template: `
    <ingo-mobile-app-modal
        (onOpenApp)="openApp()"
        (onDismiss)="dismiss()"
        (onStopShowing)="stopShowingThisModal()">
    </ingo-mobile-app-modal>`
})
export class MobileAppModalContainerComponent implements OnInit {

  private readonly storageKey = 'SHOW_MOBILE_APP_POPUP';

  constructor(
    private activeModal: NgbActiveModal,
    private storage: LocalStorageService,
    private externalLinks: ExternalLinksService
  ) { }

  ngOnInit(): void { }

  openApp(): void {
    window.location.href = this.externalLinks.getGooglePlayAppUrl();
    this.activeModal.close();
  }

  dismiss(): void {
    this.activeModal.dismiss();
  }

  stopShowingThisModal() {
    this.storage.set(this.storageKey, false);
  }
}
